<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/service-products/products" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditChannelMapping") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.ProductName")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ProductName')"
                >
                  <v-select
                    v-model="productMapping.productId"
                    :options="productDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :disabled="true"
                    :reduce="(option) => option.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{
                $t("setup.label.AvailableChannels")
              }}</small>
              <div
                class="w-full"
                style="height: 25rem; overflow: auto; padding: 2rem"
              >
                <table class="w-full">
                  <vs-tr
                    :key="availableChannel.id"
                    :data="availableChannel"
                    @click.stop="selectProduct(index)"
                    v-for="(availableChannel, index) in availableChannels"
                  >
                    <vs-td :data="availableChannel.id"
                      >{{ availableChannel.channelName }}
                    </vs-td>
                    <vs-td>
                      <div
                        style="
                          margin-left: 5rem;
                          margin-top: 0.3rem;
                          text-align: right;
                        "
                        v-if="!addedProducts[index]"
                      >
                        <vs-button
                          icon-pack="feather"
                          icon="icon-plus"
                          size="small"
                          style="width: 10rem; border-radius: 50%"
                          type="border"
                          @click="addUser(index)"
                        ></vs-button>
                        <!-- <vs-checkbox v-model="addedProducts[index]"></vs-checkbox> -->
                      </div>
                      <div v-else style="margin-left: 5rem; margin-top: 0.3rem">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-check"
                          class="mb-2"
                          color="success"
                          style="border-radius: 50%; width: 2rem"
                          @click="removeUser(index)"
                          size="small"
                        ></vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </table>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="w-full">
                <small class="date-label font-semibold">{{
                  $t("setup.label.SelectedChannels")
                }}</small>
                <div
                  class="w-full"
                  style="height: 25rem; overflow: auto; padding: 2rem"
                >
                  <vs-table description :data="selectedProducts">
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="selectedUser.id"
                        :data="selectedUser"
                        @click.stop="selectProduct(index)"
                        v-for="(selectedUser, index) in data"
                      >
                        <vs-td :data="selectedUser.channelName"
                          >{{ selectedUser.channelName }}
                        </vs-td>
                        <vs-td>
                          <div>
                            <vs-button
                              icon-pack="feather"
                              icon="icon-x"
                              class="mb-2"
                              color="warning"
                              type="border"
                              style="border-radius: 50%"
                              @click="
                                removeUser(
                                  userNames.indexOf(selectedUser.channelName)
                                )
                              "
                              size="small"
                            ></vs-button>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateProduct"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ticketEmptyObj = {
  locale: "en",
  productId: "",
  channelDetail: [],
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      productMapping: ticketEmptyObj,
      added: false,
      statuses: ["ACTIVE", "INACTIVE"],
      checked: true,
      data: {},
      addedProducts: [],
      userIds: [],
      userNames: [],
      teamIds: [],
      teamCodes: [],
      availableChannels: [],
      selectedProducts: [],
      selectedUserIds: [],
      productDatas: [],
      iconSel: "icon-plus",
      username: "",
      teamCode: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      channelMappingTemplate: (state) =>
        state.broadcaster.channelMappingTemplate,
      productMappingData: (state) => state.broadcaster.productMappingData,
    }),
  },
  methods: {
    selectProduct(index) {
      this.selectedProducts.push(this.availableChannels[index]);
    },
    addUser(index) {
      if (this.selectedProducts.indexOf(this.availableChannels[index]) != -1) {
        this.removeUser(index);
      } else {
        this.addedProducts[index] = true;

        this.selectedProducts.push(this.availableChannels[index]);
        this.availableChannels[index].icon = "icon-check";
        this.selectedUserIds.push(this.availableChannels[index].id);
      }
    },

    removeUser(index) {
      this.addedProducts[index] = false;
      let indx = this.selectedProducts.indexOf(this.availableChannels[index]);
      this.selectedProducts.splice(indx, 1);
      this.selectedUserIds.splice(indx, 1);
    },
    async updateProduct() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (this.selectedProducts.length == 0) {
        this.warningPopup = true;
        this.warningText = "Please select channels";
        return;
      }

      delete this.productMapping.id;
      delete this.productMapping.productDatas;
      delete this.productMapping.availableChannels;
      delete this.productMapping.selectedChannels;
      this.productMapping.channelDetail = this.selectedUserIds;

      try {
        await this.$store.dispatch("broadcaster/updateProductMappingAction", {
          id: this.$route.params.id,
          data: this.productMapping,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "ProductMapping Edited Successfully!",
          type: "success",
        });
        this.$router.push({ path: "/setup/service-products/products" });
        this.resetForm();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage
          .replace("The parameter", "")
          .replace("channelDetail", "Selected Channels");

        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getproductMappingTemplate() {
      try {
        await this.$store.dispatch("broadcaster/setChannelMappingTemplate");
        this.data = this.channelMappingTemplate;
        this.availableChannels = this.channelMappingTemplate.availableChannels;

        let j = 0;
        for (let temp of this.channelMappingTemplate.productDatas) {
          this.productDatas = [...this.productDatas, { label: "", value: "" }];
          this.productDatas[j].value = temp.id;
          this.productDatas[j].label = temp.productCode;
          j += 1;
        }
        for (let tempChannel of this.availableChannels) {
          if (
            this.availableChannels[this.availableChannels.indexOf(tempChannel)]
              .icon == undefined
          )
            this.availableChannels[
              this.availableChannels.indexOf(tempChannel)
            ].icon = "icon-plus";

          this.userNames.push(tempChannel.channelName);
          this.userIds.push(tempChannel.id);
        }
        this.getproductMappingData();
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getproductMappingData() {
      try {
        await this.$store.dispatch(
          "broadcaster/setProductMappingById",
          this.$route.params.id
        );
        this.productMapping = this.productMappingData;
        for (let temp of this.productMapping.selectedChannels) {
          let index = this.userIds.indexOf(temp.id);

          this.addUser(index);
        }
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    resetForm() {
      this.productMapping = ticketEmptyObj;
      this.selectedProducts = [];
      this.addedProducts = [];
      this.productMapping.productId = "";
    },
    cancel() {
      this.$router.push({ path: "/setup/service-products/products" });
    },
    dataCall() {
      setTimeout(this.getproductMappingData, 300);
    },
  },
  mounted() {
    this.getproductMappingTemplate();
  },
};
</script>
<style></style>
